import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TempScore} from "../domain/temp-score";
import {Observable} from "rxjs";
import {Config} from '../domain/config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private readonly SERVICE_URL = `/api/config`;

  constructor(private http: HttpClient) {
  }

  getConfig(): Observable<Config> {
    return this.http.get<Config>(this.SERVICE_URL);
  }

  updateConfigRewardMessage(rewardMessage: string) {
    return this.http.post<Config>(this.SERVICE_URL + "/admin/reward-message", rewardMessage)
  }

  updateUsernameMessage(usernameMessageEnabled: boolean, usernameMessage: string) {
    return this.http.post<Config>(this.SERVICE_URL + "/admin/username-message", {usernameMessageEnabled: usernameMessageEnabled, usernameMessage: usernameMessage})
  }

  updateAttemptsConfig(attemptsEnabled: boolean, attemptCooldown: string):Observable<Config> {
    return this.http.post<Config>(this.SERVICE_URL + "/admin/attempts-config", {attemptsEnabled: attemptsEnabled, attemptCooldown: attemptCooldown})
  }

}
